export default {
	tipoEstilo: 'card3', // card, transparent o estilo3 (recasur)
	estilos: [
		{ code: 'card', text: 'Tarjeta' },
		{ code: 'transparent', text: 'Trasparente' },
		{ code: 'estilo3', text: 'Tarjeta 2' },
		{ code: 'imagecard', text: 'Tarjeta Imagen' },
		{ code: 'card3', text: 'Tarjeta 3' },
	],
	views: {
		Home: {
			transparent: {
				transparentContainer: {
					/* 
					Este componente levanta una caja flotante sin fondo sobre otra caja con transparencia
					De este modo no se hereda la opacidad entre el fondo y el texto/input, se hace el fondo traslucido
					Cuando las cajas estan en "position: 'relative'" se es comodo utilizar porcentajes para margenes y tamaños
					 */
					mtd: "12%", // Margen Arriba Escritorio
					mtm: "20%", // Margen Arriba Teléfono
					wd: "60%", // Width Escritorio
					wm: "80%", // Width Arriba Teléfono
					hd: "30%", // Heigh Horizontal
					hm: "40%", // Heigh Vertical
				},
				layout:{
					type: 'transparent',
				},
				bigTitle: {
					hidden: true, 
					text: 'Check in',
					bar: false
				},
				titulo: 'Portal de check - in',
				estilos: {
					titulo: { mt: 2 },
					boton: { mb: 2, width: '40%', mx: 'auto' },
					stack: {}
				}
			},
			card: {
				transparentContainer: {
					/* 
					Este componente levanta una caja flotante sin fondo sobre otra caja con transparencia
					De este modo no se hereda la opacidad entre el fondo y el texto/input, se hace el fondo traslucido
					Cuando las cajas estan en "position: 'relative'" se es comodo utilizar porcentajes para margenes y tamaños
					 */
					mtd: "4%", // Margen Arriba Escritorio
					mtm: "11%", // Margen Arriba Teléfono
					wd: "60%", // Width Escritorio
					wm: "90%", // Width Arriba Teléfono
					hd: "30%", // Heigh Horizontal
					hm: "70%", // Heigh Vertical
					opacity:"0.0",
				},
				layout: {
					type: 'card',
				},
				bigTitle: {
					hidden: false, 
					text: 'Check in'
				},
				titulo: 'Carga de datos y documentos personales',
				estilos: {
					titulo: { p: 4 },
					boton: { mb: 2, width: '60%', mx: 'auto', borderRadius: '15px' },
					stack: { mt: 7 },
					paperWrapper: { bgcolor: 'surfaces.light', borderRadius: '20px' },
				}
			},
			estilo3: {
				transparentContainer: {
					/* 
					Este componente levanta una caja flotante sin fondo sobre otra caja con transparencia
					De este modo no se hereda la opacidad entre el fondo y el texto/input, se hace el fondo traslucido
					Cuando las cajas estan en "position: 'relative'" se es comodo utilizar porcentajes para margenes y tamaños
					 */
					mtd: "6%", // Margen Arriba Escritorio
					mtm: "11%", // Margen Arriba Teléfono
					wd: "60%", // Width Escritorio
					wm: "90%", // Width Arriba Teléfono
					hd: "30%", // Heigh Horizontal
					hm: "70%", // Heigh Vertical
					opacity:"0.0",
				},
				layout: {
					type: 'card',
				},
				bigTitle: {
					hidden: true, 
					text: 'Check in',
					bar: false
				},
				mensaje: 'Bienvenido al portal de Check In',
				titulo: 'Carga de datos y documentos personales',
				estilos: {
					titulo: { 
						color: 'text.white', bgcolor: 'primary.main', 
						fontSize: '18px', fontWeight: 700, mb:1 
					},
					boton: { my: 2, mx: 'auto' },
					stack: { },
					cuerpo: { color: 'text.input', fontSize: '18px', fontWeight: 300, textAlign: 'center', mt: 2, p: 1 },
					paperWrapper: { bgcolor: 'surfaces.light', borderRadius: 0 },
				}
			},
			imagecard: {
				transparentContainer: {
					/* 
					Este componente levanta una caja flotante sin fondo sobre otra caja con transparencia
					De este modo no se hereda la opacidad entre el fondo y el texto/input, se hace el fondo traslucido
					Cuando las cajas estan en "position: 'relative'" se es comodo utilizar porcentajes para margenes y tamaños
					 */
					mtd: "12%", // Margen Arriba Escritorio
					mtm: "40%", // Margen Arriba Teléfono
					wd: "60%", // Width Escritorio
					wm: "80%", // Width Arriba Teléfono
					hd: "30%", // Heigh Horizontal
					hm: "40%", // Heigh Vertical
				},
				layout:{
					type: 'transparent',
				},
				bigTitle: {
					hidden: true, 
					text: 'Check in',
					bar: false
				},
				titulo: 'Portal de check - in',
				estilos: {
					titulo: { mt: 2, color: 'surfaces.light' },
					stack: { p: 0, bgcolor: 'surfaces.dark', borderRadius: '10px' },
					boton: { mb: 2, width: '40%', mx: 'auto', bgcolor: 'surfaces.dark', color: 'text.white' }
				}
			},
			card3: {
				transparentContainer: {
					/* 
					Este componente levanta una caja flotante sin fondo sobre otra caja con transparencia
					De este modo no se hereda la opacidad entre el fondo y el texto/input, se hace el fondo traslucido
					Cuando las cajas estan en "position: 'relative'" se es comodo utilizar porcentajes para margenes y tamaños
					 */
					mtd: "8%", // Margen Arriba Escritorio
					mtm: "44%", // Margen Arriba Teléfono
					wd: "60%", // Width Escritorio
					wm: "90%", // Width Arriba Teléfono
					hd: "30%", // Heigh Horizontal
					hm: "70%", // Heigh Vertical
				},
				layout: {
					type: 'transparent',
				},
				bigTitle: {
					hidden: true, 
					text: 'Check in'
				},
				titulo: 'Carga de datos y documentos personales',
				estilos: {
					titulo: { p: 4 },
					boton: { mb: 2, width: '30%', mx: 'auto', bgcolor: 'secondary.main', color: 'text.white', borderRadius: '26px', },
					stack: { mt: 0, bgcolor: 'surfaces.dark', borderRadius: '26px' },
					paperWrapper: { },
				}
			},
		},
		CheckInLogin: {
			transparent: {
			  transparentContainer: {
				mtd: "4%", mtm: "11%", wd: "60%", wm: "90%", hd: "50%", hm: "60%",
				},
				layout: {
					type: 'transparent',
				},
			  bigTitle: { hidden: true },
			  titulo: 'Inicio de Sesión',
			  estilos: {
				stack: { p: 0 },
				gridContainer: { p: 0 },
				gridItem: { px: 1, mt: 1, height: '100%' },
				submitButton: { width: '100%', color: 'white' },
			  }
			},
			card: {
			  transparentContainer: {
				mtd: "4%", mtm: "11%", wd: "60%", wm: "90%", hd: "50%", hm: "60%",
				opacity: "0.0", 
				},
				layout: {
					type: 'card',
				},
			  bigTitle: { hidden: false, text: 'Login' },
			  titulo: 'Inicio de Sesión',
			  estilos: {
				stack: { p: 2, mt: 2 },
				gridContainer: { p: 0 },
				gridItem: { px: 1, mt: 1, height: '100%' },
				submitButton: { width: '100%', color: 'white' },
				paperWrapper: { bgcolor: 'surfaces.light', borderRadius: '20px' },
			  }
			},
			estilo3: {
			  transparentContainer: {
				mtd: "7%", mtm: "11%", wd: "60%", wm: "90%", hd: "50%", hm: "60%",
				opacity: "0.0", 
				},
				layout: {
					type: 'card',
				},
			  bigTitle: { hidden: true, text: 'Login' },
			  titulo: 'Inicio de Sesión',
			  estilos: {
				stack: { pb: 2 },
				titulo: { 
					color: 'text.white', bgcolor: 'primary.main', 
					fontSize: '18px', fontWeight: 700, mb:3
				},
				gridContainer: { p: 0 },
				gridItem: { px: 2, mt: 1, height: '100%' },
				submitButton: { mt: 2 },
				paperWrapper: { bgcolor: 'surfaces.light', borderRadius: 0  },
			  }
			},
			imagecard: {
				transparentContainer: {
				  mtd: "6%", mtm: "20%", wd: "60%", wm: "90%", hd: "50%", hm: "60%",
				  },
				  layout: {
					  type: 'transparent',
				  },
				bigTitle: { hidden: true },
				titulo: 'Inicio de Sesión',
				estilos: {
				  titulo: { color: 'surfaces.light' },
				  stack: { p: 0, bgcolor: 'surfaces.backgroundcard', borderRadius: '10px' },
				  gridContainer: { p: 0 },
				  gridItem: { px: 1, mt: 1, height: '100%' },
				  submitButton: { width: '40%', color: 'white', mx: 'auto', mb: 1 },
				}
			  },
			  card3: {
				transparentContainer: {
				  mtd: "5%", mtm: "11%", wd: "60%", wm: "90%", hd: "50%", hm: "30%",
				  opacity: "0.0", 
				  },
				  layout: {
					heightAdjust: false,
					extraBackgroundSx: { mt: 5 },
					  type: 'card',
				  },
				bigTitle: { hidden: true, text: 'Login' },
				titulo: 'Inicio de Sesión',
				estilos: {
				  stack: { p: 2, mt: 2 },
				  gridContainer: { p: 0 },
				  gridItem: { px: 1, mt: 1, height: '100%' },
				  submitButton: { mt: 2, mb: 2, width: '100%', mx: 'auto', bgcolor: 'secondary.main', textAlign: 'center', color: 'text.white'},
				  paperWrapper: {  mt: 0, bgcolor: 'surfaces.dark', borderRadius: '26px' },
				}
			  },
		},
		CheckInStep1: {
            transparent: {
                transparentContainer: { mtd: "8%", mtm: "11%", wd: "70%", wm: "90%", hd: "auto", hm: "auto" },
				layout: {
					heightAdjust: true,
					extraBackgroundSx: { mt: 5 },
					type: 'transparent',
				},
                bigTitle: { hidden: true },
                titulo: 'Datos personales',
                estilos: {
                    stack: { p: 2 },
                    gridItem: { px: 1, mt: 1 },
                    submitButton: { color: 'white', height: '50px', width: '100%', fontSize: 18, mt: 2 }
                }
            },
            card: {
                transparentContainer: { mtd: "4%", mtm: "11%", wd: "70%", wm: "90%", hd: "auto", hm: "auto", opacity: "0.0" },
				layout: {
					heightAdjust: true,
					extraBackgroundSx: { mt: 40 },
					type: 'card',
				},
                bigTitle: { hidden: false, text: 'Check in paso 1' },
                titulo: 'Datos personales',
                estilos: {
                    stack: { p: 2 },
                    gridItem: { p: 1 },
                    submitButton: { color: 'white', height: '50px', width: '100%', fontSize: 18 },
					paperWrapper: { bgcolor: 'surfaces.light', borderRadius: '20px' },
                }
            },
            estilo3: {
                transparentContainer: { mtd: "7%", mtm: "11%", wd: "70%", wm: "90%", hd: "auto", hm: "auto", opacity: "0.0" },
				layout: {
					heightAdjust: true,
					extraBackgroundSx: { mt: 40 },
					type: 'card',
				},
                bigTitle: { hidden: true, text: 'Check in paso 1' },
                titulo: 'Check in paso 1',
                estilos: {
                    stack: { pb: 2 },
					titulo: { 
						color: 'text.white', bgcolor: 'primary.main', 
						fontSize: '18px', fontWeight: 700, mb:3
					},
					gridContainer: { p: 0 },
					gridItem: { px: 2, mt: 1, height: '100%' },
					submitButton: { mt: 2 },
					paperWrapper: { bgcolor: 'surfaces.light', borderRadius: 0  },
                }
            },
			imagecard: {
                transparentContainer: { mtd: "8%", mtm: "11%", wd: "70%", wm: "90%", hd: "auto", hm: "auto" },
				layout: {
					heightAdjust: true,
					extraBackgroundSx: { mt: 5 },
					type: 'transparent',
				},
                bigTitle: { hidden: true },
                titulo: 'Datos personales',
                estilos: {
					titulo: { mt: 2, color: 'surfaces.light' },
					stack: { p: 2, bgcolor: 'surfaces.backgroundcard', borderRadius: '10px' },
                    gridItem: { px: 1, mt: 1 },
                    submitButton: { color: 'white', height: '50px', width: '100%', fontSize: 18, mt: 2 }
                }
            },
            card3: {
                transparentContainer: { mtd: "2%", mtm: "11%", wd: "70%", wm: "90%", hd: "auto", hm: "30%", opacity: "0.0" },
				layout: {
					heightAdjust: false,
					extraBackgroundSx: { mt: 5 },
					  type: 'card',
				  },
                bigTitle: { hidden: true, text: 'Check in paso 1' },
                titulo: 'Datos personales',
                estilos: {
                    stack: { p: 2, mt: 2 },
					gridContainer: { p: 0},
					gridItem: { px: 1, mt: 1, height: '100%' },
					submitButton: { mt: 2, mb: 2, width: '100%', mx: 'auto', bgcolor: 'secondary.main', textAlign: 'center', color: 'text.white', borderRadius: '26px' },
					paperWrapper: { mt: 0, bgcolor: 'surfaces.dark', borderRadius: '26px' },
                }
            },
        },
		CheckInStep2: {
            transparent: {
                transparentContainer: {
                    mtd: "5%", mtm: "11%", wd: "70%", wm: "90%",
                    hd: "90%", hm: "130%"
                    
				},
				layout: {
					heightAdjust: true,
					extraBackgroundSx: { mt: 5 },
					type: 'transparent',
				},
				warrantyExtraBackgroundSx: { mt: 35 },
                bigTitle: { hidden: true },
                titulo: 'Carga de Documentos', 
                estilos: {
                    titulo: { mt: 2, p: 4 },
                    gridItem: { px: 5 },
                    gridItemMobile: { px: 1 },
                    warrantyButton: { color: 'white', mt: 2, width: '100%', fontSize: 14 },
                    submitButton: { color: 'white', height: '50px', width: '100%', fontSize: 18 }
                }
            },
            card: { 
				transparentContainer: {
					mtd: "1%",
					mtm: "5%", 
					wd: "85%",
					wm: "95%",
					hd: "auto",
					hm: "auto",
					opacity: "0.0",
				},
				layout: {
					heightAdjust: true,
					extraBackgroundSx: { mt: 40 },
					type: 'card',
				},
				warrantyExtraBackgroundSx: { mt: 70 },
				bigTitle: { hidden: false, text: 'Check in paso 2' },
				titulo: '',
				estilos: {
					stack: { p: 2, mt: 2 }, 
					gridItem: { px: 2, mb: 2 },
					gridItemMobile: { px: 1, mb: 2 },
					warrantyButton: { color: 'white', height: '50px', width: '100%', fontSize: 18 },
					submitButton: { color: 'white', height: '50px', width: '100%', fontSize: 18, px: 5, mt: 2 },
					paperWrapper: { bgcolor: 'surfaces.light', borderRadius: '20px' },
				}
			},
            estilo3: { 
				transparentContainer: {
					mtd: "7%",
					mtm: "5%", 
					wd: "85%",
					wm: "95%",
					hd: "auto",
					hm: "auto",
					opacity: "0.0",
				},
				layout: {
					heightAdjust: true,
					extraBackgroundSx: { mt: 40 },
					type: 'card',
				},
				warrantyExtraBackgroundSx: { mt: 70 },
				bigTitle: { hidden: true, text: 'Check in paso 2' },
				titulo: 'Check in paso 2',
				estilos: {
					stack: { pb: 2 },
					titulo: { 
						color: 'text.white', bgcolor: 'primary.main', 
						fontSize: '18px', fontWeight: 700, mb:3
					},
					submitButton: { mt: 2 },
					gridItem: { px: 2, mt: 1, height: '100%' },
					gridItemMobile: { px: 1, mt: 1, height: '100%' },
					warrantyButton: { color: 'white', height: '50px', width: '100%', fontSize: 18 },
					paperWrapper: { bgcolor: 'surfaces.light', borderRadius: 0  },
				}
			},
			imagecard: {
                transparentContainer: {
                    mtd: "5%", mtm: "11%", wd: "70%", wm: "90%",
                    hd: "90%", hm: "130%"
                    
				},
				layout: {
					heightAdjust: true,
					extraBackgroundSx: { mt: 40 },
					type: 'transparent',
				},
				warrantyExtraBackgroundSx: { mt: 35 },
                bigTitle: { hidden: true },
                titulo: 'Carga de Documentos', 
                estilos: {
					titulo: { mt: 2, p: 4, color: 'surfaces.light' },
					stack: { p: 0, bgcolor: 'surfaces.backgroundcard', borderRadius: '10px' },
                    gridItem: { px: 5 },
                    gridItemMobile: { px: 1 },
                    warrantyButton: { color: 'white', mt: 2, width: '100%', fontSize: 14 },
                    submitButton: { color: 'white', height: '50px', width: '100%', fontSize: 18 }
                }
            },
            card3: { 
				transparentContainer: {
					mtd: "2%",
					mtm: "5%", 
					wd: "85%",
					wm: "95%",
					hd: "auto",
					hm: "auto",
					opacity: "0.0",
				},
				layout: {
					heightAdjust: true,
					extraBackgroundSx: { mt: 5 },
					type: 'card',
				},
				warrantyExtraBackgroundSx: { mt: 35 },
				bigTitle: { hidden: true, text: 'Check in paso 2' },
				titulo: '',
				estilos: {
					stack: { p: 2, mt: 2 }, 
					gridItem: { px: 2, mb: 2 },
					gridItemMobile: { px: 1, mb: 2 },
					warrantyButton: { mt: 2, mb: 2, width: '30%', mx: 'auto', bgcolor: 'surfaces.backgroundcard', textAlign: 'center', color: 'text.white', borderRadius: '26px' },
					submitButton: { mt: 2, mb: 2, width: '100%', mx: 'auto', bgcolor: 'secondary.main', textAlign: 'center', color: 'text.white', borderRadius: '26px' },
					paperWrapper: { mt: 0, bgcolor: 'surfaces.dark', borderRadius: '26px' },
				}
			},
        },
		Finish: {
			transparent: {
			  transparentContainer: {
				mtd: "12%", mtm: "20%", wd: "60%", wm: "80%", 
				hd: "30%", hm: "60%"
			  },
			  layout: {
				type: 'transparent',
			},
			  bigTitle: { hidden: true },
			  titulo: 'CHECK - IN EXITOSO',
			  mensaje: 'Ha completado el check - in enviando sus datos personales, documentos legales y su información para la toma de garantía.',
			  estilos: {
				stack: { mt: 2, p: 2, alignItems: 'center' },
				titulo: { color: 'surfaces.light', fontSize: '32px', fontWeight: 600, textAlign: 'center' },
				cuerpo: { color: 'primary.main', fontSize: '18px', fontWeight: 300, textAlign: 'center', mt: 2 }
			  }
			},
			card: {
			  transparentContainer: {
				mtd: "8%", mtm: "11%", wd: "60%", wm: "80%", 
				hd: "30%", hm: "60%", opacity: "0.0"
			  },
			  layout: {
				type: 'card',
			},
			  bigTitle: { hidden: true },
			  titulo: 'CHECK - IN EXITOSO',
			  mensaje: 'Ha completado el check - in enviando sus datos personales, documentos legales y su información para la toma de garantía.',
			  estilos: {
				stack: { mt: 2, p: 4, alignItems: 'center' },
				titulo: { color: 'primary.main', fontSize: '32px', fontWeight: 600, textAlign: 'center' },
				cuerpo: { color: 'text.input', fontSize: '18px', fontWeight: 300, textAlign: 'center', mt: 2 },
				paperWrapper: { bgcolor: 'surfaces.light', borderRadius: '20px' },
			  }
			},
			estilo3: {
			  transparentContainer: {
				mtd: "8%", mtm: "11%", wd: "60%", wm: "80%", 
				hd: "30%", hm: "60%", opacity: "0.0"
			  },
			  layout: {
				type: 'card',
			},
			  bigTitle: { hidden: true },
			  titulo: 'CHECK - IN EXITOSO',
			  mensaje: 'Ha completado el check - in enviando sus datos personales, documentos legales y su información para la toma de garantía.',
			  estilos: {
				stack: { pb: 2 },
				titulo: { 
					color: 'text.white', bgcolor: 'primary.main', 
					fontSize: '18px', fontWeight: 700, mb:3
				},
				cuerpo: { color: 'text.input', fontSize: '18px', fontWeight: 300, textAlign: 'center', p: 3 },
				paperWrapper: { bgcolor: 'surfaces.light', borderRadius: 0 },
			  }
			},
			imagecard: {
				transparentContainer: {
				  mtd: "12%", mtm: "20%", wd: "60%", wm: "80%", 
				  hd: "30%", hm: "60%"
				},
				layout: {
				  type: 'transparent',
			  },
				bigTitle: { hidden: true },
				titulo: 'CHECK - IN EXITOSO',
				mensaje: 'Ha completado el check - in enviando sus datos personales, documentos legales y su información para la toma de garantía.',
				estilos: {
				  titulo: { mt: 2, color: 'surfaces.light' },
				  stack: { p: 2, alignItems: 'center', bgcolor: 'surfaces.backgroundcard', borderRadius: '10px' },
				  titulo: { color: 'surfaces.light', fontSize: '32px', fontWeight: 600, textAlign: 'center' },
				  cuerpo: { color: 'surfaces.light', fontSize: '18px', fontWeight: 300, textAlign: 'center', my: 2, pb: 2 }
				}
			  },
			  card3: {
				transparentContainer: {
				  mtd: "8%", mtm: "11%", wd: "60%", wm: "80%", 
				  hd: "30%", hm: "60%", opacity: "0.0"
				},
				layout: {
				  type: 'card',
			  },
				bigTitle: { hidden: true },
				titulo: 'CHECK - IN EXITOSO',
				mensaje: 'Ha completado el check - in enviando sus datos personales, documentos legales y su información para la toma de garantía.',
				estilos: {
				  stack: { mt: 2, p: 4, alignItems: 'center' },
				  titulo: { color: 'surfaces.backgroundcard', fontSize: '32px', fontWeight: 600, textAlign: 'center' },
				  cuerpo: { color: 'text.white', fontSize: '18px', fontWeight: 300, textAlign: 'center', mt: 2 },
				  paperWrapper: { bgcolor: 'surfaces.dark', borderRadius: '26px' },
				}
			  },
		}
    }
};